module.exports = __webpack_public_path__ + "img/CAR.4cf230bc.svg";